import { MeetingFormValues } from "@/pages/workflows/edit/actions/meeting/workflow-meeting.schema.ts";
import { ApiCalendar, ApiCalendarProviders } from "@/types/calendar.types.ts";
import { Select, Stack, Text } from "@skailer-com/uikit";
import { Control, Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";

interface MeetingCalendarFieldProps {
  control: Control<MeetingFormValues>;
  calendars: ApiCalendar[] | undefined;
  organizerId: number | null;
  error?: string;
  onCalendarChange: (value: number | null) => void;
}

export const MeetingCalendarField = ({
  control,
  calendars,
  organizerId,
  error,
  onCalendarChange,
}: MeetingCalendarFieldProps) => {
  const { t } = useTranslation();

  return (
    <Controller
      control={control}
      name="calendar_id"
      render={({ field: { value } }) => (
        <Stack gap={"xs"}>
          <Select
            label={t("workflow:action_type_meeting_calendar")}
            emptyTitle={t("common:select")}
            required
            disabled={!organizerId}
            value={value}
            showCaption
            options={(calendars ?? []).map((calendar) => ({
              id: calendar.id,
              title: calendar.title,
              caption:
                calendar.provider === ApiCalendarProviders.google_calendar
                  ? t("workflow:action_type_meeting_calendar_provider_google")
                  : t("workflow:action_type_meeting_calendar_provider_system"),
            }))}
            error={error}
            onChange={(newValue) => onCalendarChange(newValue as number | null)}
          />
          {!organizerId && (
            <Text className={"text-secondary text-sm"}>
              {t("workflow:action_type_meeting_calendar_select_organizer")}
            </Text>
          )}
        </Stack>
      )}
    />
  );
};
